export const LibConfig = {
	isProduction: true as boolean,
	healthIndividualApiUrl: '' as string,
	authApiUrl: '' as string,
};

export const setCustomerLibConfig = (options: typeof LibConfig) => {
	Object.keys(LibConfig).forEach((key) => {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		(LibConfig as any)[key] = (options as any)[key];
	});
};
